var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['price', _vm.color, _vm.size],attrs:{"data-qa":"priceCurrent"}},[_vm._v("\n  "+_vm._s(_vm.price)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }